import React from 'react'
import { IconCircleCheck,IconCircleMinus, IconCircleX } from '@tabler/icons-react';
import { Tooltip } from '@mantine/core';

export default function ActivityBadge({state,dateOfMembership}) {
    dateOfMembership = new Date(dateOfMembership)
    if(!dateOfMembership)return <IconCircleX color='red'/>
    if(state === 'active' ) return <ActiveBadge/>
    if(state === 'inactive' && dateOfMembership) return <InactiveBadge/>
        return (
            <IconCircleMinus color='orange' />
        )

        function InactiveBadge(){
            return <Tooltip label={`Inactif depuis ${dateOfMembership.getFullYear()+1}`} ><IconCircleX color='red'/></Tooltip>
        }
        function ActiveBadge(){
            return <Tooltip label={`À renouvelé le ${dateOfMembership.toLocaleDateString('fr-FR', { day: 'numeric', month: 'long', year: 'numeric' })}`} ><IconCircleCheck color='green'/></Tooltip>
        }
}

